import {
    getRemoteConfig,
    fetchAndActivate,
    getAll,
} from 'firebase/remote-config';

import { firebaseApp } from '../index';

import { default as defaultConfig } from './default-remote-config.json';
import { RemoteConfig } from './types';

const remoteConfig = getRemoteConfig(firebaseApp);
remoteConfig.defaultConfig = defaultConfig as any;

remoteConfig.settings = {
    minimumFetchIntervalMillis: 60000, // 1 minute
    fetchTimeoutMillis: 60000, // 1 minute
};

const fetchRemoteConfig = async () => {
    await fetchAndActivate(remoteConfig);
    const remote = getAll(remoteConfig);

    const config: Record<string, any> = {};
    for (const entry of Object.entries(remote)) {
        const [key, { _value: value }] = entry as any;
        config[key] = JSON.parse(value);
    }

    return config as RemoteConfig;
};

export { fetchRemoteConfig };
